import { type PropsWithChildren } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  label?: string;
  className?: string;
  dataTestId: string;
  isFormType?: boolean;
};

export function FormGroup({
  children,
  label,
  className,
  dataTestId,
}: PropsWithChildren<Props>) {
  return (
    <div className={cnTwMerge("p-6 rounded-lg border", className)}>
      {isTruthy(label) ? (
        <div className="text-base font-semibold text-text/primary mb-6">
          {label}
        </div>
      ) : null}
      <div
        className={cnTwMerge("space-y-12 [&>div]:gap-y-6")}
        data-testid={`form-section-${dataTestId}`}
      >
        {children}
      </div>
    </div>
  );
}

export function FormGroupChild({ children }: PropsWithChildren<Props>) {
  return <div className="pl-0 sm:pl-8 space-y-4">{children}</div>;
}
